import React from 'react';

import { TypographyVariantsEnum } from '../../../../../utils/_enums/typeography-variants.enum';
import { Typography } from '../../../../_shared/typography/typography';
import styles from './variant-detail-meta-box-keywords.module.scss';

export interface Props {
    variant?: 'keyword' | 'genre';
}

export const VariantDetailStageMetaBoxKeywords: React.FC<Props> = ({
    variant,
    children
}) => {
    return (
        <div
            className={`${styles['variant-detail-meta-box-keywords']} ${
                styles[variant as string]
            }`}
        >
            <Typography variant={TypographyVariantsEnum.KEYWORD_TITLE} disableMarkdown={true}>
                {children}
            </Typography>
        </div>
    );
};

VariantDetailStageMetaBoxKeywords.defaultProps = { variant: 'genre' };
